import { HttpParams } from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { USER_ADD_ONS, USER_PLANS } from "../common/endpoints";
import { DigitalService } from "../model";
import { AuthenticationService } from "./authentication.service";
import { HttpService } from "./http.service";

@Injectable()
export class DigitalServiceService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService,
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService
    ) { }

    private customerPlans: DigitalService[];
    private partnerPlans: DigitalService[];
    private userPlans: DigitalService[];
    private customerAddOns: DigitalService[];
    private partnerAddOns: DigitalService[];
    private userAddOns: DigitalService[];

    loadDigitalServices(): void {
        if (this.authenticationService.isOrganizationUser()) {
            firstValueFrom(this.httpService.get<DigitalService[]>(USER_PLANS, new HttpParams().set('configType', 'CUSTOMER'))).then(plans => this.customerPlans = plans);
            firstValueFrom(this.httpService.get<DigitalService[]>(USER_ADD_ONS, new HttpParams().set('configType', 'CUSTOMER'))).then(addOns => this.customerAddOns = addOns);
            firstValueFrom(this.httpService.get<DigitalService[]>(USER_PLANS, new HttpParams().set('configType', 'PARTNER'))).then(plans => this.partnerPlans = plans);
            firstValueFrom(this.httpService.get<DigitalService[]>(USER_ADD_ONS, new HttpParams().set('configType', 'PARTNER'))).then(addOns => this.partnerAddOns = addOns);
        } else {
            firstValueFrom(this.httpService.get<DigitalService[]>(USER_PLANS)).then(plans => this.userPlans = plans);
            firstValueFrom(this.httpService.get<DigitalService[]>(USER_ADD_ONS)).then(addOns => this.userAddOns = addOns);
        }
    }

    getPlanLabel(planName: string, partner?: boolean): string {
        let plans;
        if (this.authenticationService.isOrganizationUser()) {
            if (partner) {
                plans = this.partnerPlans;
            } else {
                plans = this.customerPlans;
            }
        } else {
            plans = this.userPlans;
        }
        return plans.find(p => p.name == planName)?.label;
    }

    getAddOnLabels(addOnNames: string | string[], partner?: boolean): string | string[] {
        let addOns;
        if (this.authenticationService.isOrganizationUser()) {
            if (partner) {
                addOns = this.partnerAddOns;
            } else {
                addOns = this.customerAddOns;
            }
        } else {
            addOns = this.userAddOns;
        }
        if (Array.isArray(addOnNames)) {
            return addOnNames.map(n => addOns.find(a => a.name == n)?.label);
        } else {
            return addOns.find(a => a.name == addOnNames)?.label
        }
    }

}